// Region returned from Salesforce when useNewDest=false
export enum LegacyApiRegion {
  Africa = 'Africa',
  Alaska = 'Alaska',
  Asia = 'Asia',
  EasternEurope = 'Europe: Eastern',
  AustraliaAndNewZealand = 'Australia & New Zealand',
  Caribbean = 'Caribbean',
  CentralAndSouthAmerica = 'Central & South America',
  CentralWesternEurope = 'Europe: Central & Western',
  Hawaii = 'Hawaii',
  ScandinaviaAndIceland = 'Europe: Northern Scandinavia & Iceland',
  SouthernEuropeAndMediterranean = 'Europe: Southern & Mediterranean',
  Mexico = 'Mexico',
  TahitiAndSouthPacific = 'South Pacific & Tahiti',
  UKAndIreland = 'Europe: United Kingdom & Ireland',
  USAAndCanada = 'United States & Canada',
  Other = 'Other',
}

// Region used on web to display labels when useNewDest=false
export enum LegacyRegion {
  Africa = 'Africa',
  Alaska = 'Alaska',
  Asia = 'Asia',
  EasternEurope = 'Eastern Europe',
  AustraliaAndNewZealand = 'Australia & New Zealand',
  Caribbean = 'Caribbean',
  CentralAndSouthAmerica = 'Central & South America',
  CentralWesternEurope = 'Western & Central Europe',
  Hawaii = 'Hawaii',
  ScandinaviaAndIceland = 'Scandinavia & Iceland',
  SouthernEuropeAndMediterranean = 'Southern Europe & Mediterranean',
  Mexico = 'Mexico',
  TahitiAndSouthPacific = 'South Pacific & Tahiti',
  UKAndIreland = 'UK & Ireland',
  USAAndCanada = 'Mainland U.S. & Canada',
  Other = 'Other',
}

// Region returned from Salesforce when useNewDest=true
export enum ApiRegion {
  AfricaNorth = 'Africa - Northern & Sahara',
  AfricaSafariEastSouthern = 'Africa - Southern & Safari',
  ArcticAntarctica = 'Arctic & Antarctica',
  AsiaEast = 'Asia - East',
  AsiaSouth = 'Asia - South',
  AsiaSoutheast = 'Asia - Southeast',
  AustraliaAndNewZealand = 'Australia & New Zealand',
  Canada = 'Canada',
  CaribbeanEasternSouthern = 'Caribbean - Eastern & Southern',
  CaribbeanWestern = 'Caribbean - Western',
  CentralAmerica = 'Central America',
  EuropeanEastern = 'Europe - Eastern',
  EuropeanMediterranean = 'Europe - Mediterranean',
  EuropeanUKAndIreland = 'Europe - UK & Ireland',
  EuropeanWesternNorthern = 'Europe - Western & Northern',
  Mexico = 'Mexico',
  MiddleEast = 'Middle East',
  SouthAmerica = 'South America',
  SouthPacific = 'South Pacific',
  Unknown = 'Unknown',
  Alaska = 'USA - Alaska',
  Hawaii = 'USA - Hawaii',
  USAMainland = 'USA - Mainland',
}

// Region used on web to display labels when useNewDest=true
export enum Region {
  AfricaNorth = 'North Africa',
  AfricaSafariEastSouthern = 'East & Southern Africa Safari',
  ArcticAntarctica = 'Arctic & Antarctica',
  AsiaEast = 'East Asia',
  AsiaSouth = 'South Asia',
  AsiaSoutheast = 'Southeast Asia',
  AustraliaAndNewZealand = 'Australia & New Zealand',
  Canada = 'Canada',
  CaribbeanEasternSouthern = 'Caribbean - Eastern & Southern',
  CaribbeanWestern = 'Caribbean - Western',
  CentralAmerica = 'Central America',
  EuropeanEastern = 'Eastern Europe',
  EuropeanMediterranean = 'Southern Europe & Mediterranean',
  EuropeanUKAndIreland = 'UK & Ireland',
  EuropeanWesternNorthern = 'Western & Northern Europe',
  Mexico = 'Mexico',
  MiddleEast = 'Middle East',
  SouthAmerica = 'South America',
  SouthPacific = 'South Pacific',
  Unknown = 'Other',
  Alaska = 'Alaska',
  Hawaii = 'Hawaii',
  USAMainland = 'Mainland U.S.',
}
